import Select from 'react-select';

const MultiSelect = props => {
    return <Select {...props} defaultValue={props.defaultValue} isMulti="true" options={props.options} />;
};

export default MultiSelect;
